import React from 'react';
import { Box } from '@material-ui/core';
import styles from './SGSPageTitle.module.scss';
import { useTranslation } from 'react-i18next';
// import bgBulleOne from '../../assets/bg_bulle-header-blue.svg';
// import bgMediatorDuotoneBlue from '../../assets/bg_mediator-duotone-blue.svg';
import { useAppContext, useDrawerContext, usePageTitleContext } from 'core/contexts';
import UserInfo from 'components/Layout/Header/UserInfo';
import classNames from 'classnames';
import { useQuery } from 'react-query';
import { historyService } from 'core/services';
import { useQueryConf } from 'core/utils/useQuery';
import { format, parseISO } from 'date-fns';

type Props = {
    title: string;
    category?: string;
    description?: JSX.Element;
    icon: string;
};

const SGSPageTitle: React.FC<Props> = ({ title, category, description, icon }) => {
    const { t } = useTranslation();
    const { pageTitle } = usePageTitleContext();
    const { drawerOpen } = useDrawerContext();
    const { user } = useAppContext();

    // last history import
    const { isLoading, data: lastImport } = useQuery([user.login, 'last_import'], async () => await historyService.getLastHistoryImport({ type: '360' }), useQueryConf);

    return (
        <Box className={styles.container}>
            <Box className={classNames(styles.headerContainer, !drawerOpen ? styles.headerContainerSmallPadding : null)}>
                <Box className={styles.headerTitleContainer}>
                    <Box display="flex" flex="1" mt={1} alignItems="center">
                        {icon && <img src={icon} alt={title} className={styles.icon} />}
                        <Box className={styles.titleContainer}>
                            {category && (
                                <Box component="span" className={styles.category}>
                                    {t(category)}
                                </Box>
                            )}
                            <Box component="span" className={styles.title}>
                                {pageTitle ?? t(title)}
                            </Box>
                            <Box className={styles.description}>{description}</Box>
                        </Box>
                    </Box>
                    <Box display="flex" mr={4} alignSelf="flex-start" justifyContent="flex-end" id="toto">
                        <UserInfo />
                    </Box>
                </Box>
                {!isLoading && lastImport?.date && (
                    <Box
                        style={{ width: '100%', height: '60px', marginTop: '-60px', zIndex: 1, paddingRight: '93px', color: 'white', fontStyle: 'italic', fontFamily: '"Open Sans", sans-serif' }}
                        className={'text-right '}
                    >
                        Données mises à jour <br />
                        le <strong>{format(parseISO(lastImport.date), 'dd/MM/yy')}</strong> à <strong>{format(parseISO(lastImport.date), 'HH:mm:ss')}</strong>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default SGSPageTitle;
